import { reducer as userReducer } from './slice';

export * from './actions';
// export * from './middlewares';
export * from './selectors';

export default userReducer;
